// Requiere que ya esté cargado vuex en la instancia de Vue

import VueI18n from 'vue-i18n'

import Contexts from 'js/vue-plugins/vue-i18n/contexts'

import buildMessageObject from './build-message-object'

import esLocale from 'element-ui/lib/locale/lang/es'
import enLocale from 'element-ui/lib/locale/lang/en'
import frLocale from 'element-ui/lib/locale/lang/fr'
import ptLocale from 'element-ui/lib/locale/lang/pt'
import deLocale from 'element-ui/lib/locale/lang/de'
import vaLocale from 'element-ui/lib/locale/lang/ca'

const availableLocales = Vue.store.state.languages
// const locale = Vue.store.state.language
const fallbackLocale = Vue.store.state.fallbackLocale

function getStartLocale(){
  if(localStorage.getItem('app-language')) return localStorage.getItem('app-language')
  let navigatorLanguages = navigator.languages.map(lang => lang.slice(0, 2))
  navigatorLanguages.forEach((navLang) => {
    if(availableLocales.includes(navLang)) return navLang
  })
  return fallbackLocale
}

const locale = getStartLocale()
Vue.store.commit('setUserLanguage', locale)

Vue.use(VueI18n)

const messages = {
  en: {...enLocale},
  es: {...esLocale},
  fr: {...frLocale},
  pt: {...ptLocale},
  de: {...deLocale},
  va: {...vaLocale}
}

Contexts.forEach(context => {
  context.keys().forEach(filename => {
    buildMessageObject(context, filename, availableLocales, messages)
  })
})

const i18n = new VueI18n({
  locale,
  fallbackLocale,
  // Congelamos el objeto para que vue no aplique reactividad a él
  messages: Object.freeze(messages)
})

Vue.i18n = i18n

export default i18n
